<template>
  <div>
    <div class="title">
      <van-icon name="arrow-left" class="lefticon" @click="goBack()" />
      <p>系统介绍</p>
    </div>
    <div class="container">
      <div
        class="main"
      >万方数据文献相似性检测服务采用科学先进的检测技术，实现海量学术文献数据全文比对，秉持客观、公正、精准、全面的服务原则，为用户提供精准详实的相似性检测结果，呈现多版本、多维度的检测报告。同时，万方数据文献相似性检测服务践行专业场景化服务的建设原则，其系列产品可有效为科研管理、教育教学、出版发行、人事管理等各领域的学术个体或学术机构提供学术成果相似性检测服务。</div>
      <div class="main" style="font-weight: bold;">海量学术全文比对资源</div>

      <div
        class="main"
      >万方数据文献相似性检测服务基于万方数据中国学术期刊数据库、中国学位论文全文数据库、中国学术会议论文数据库、中国学术网页数据库、中国专利全文数据库、中国优秀报纸数据库收录的海量学术资源实现全文比对相似性检测。</div>

      <div class="main" style="font-weight: bold;">多维的检测结果服务</div>

      <div
        class="main"
      >万方数据文献相似性检测服务针对不同产品场景定制不同版本检测报告，报告获取便捷快速；检测结果客观、准确、详实，多种版本检测报告帮助您轻松阅读结果内容、准确获取结果信息！</div>
      <div class="main" style="font-weight: bold;">科学先进的检测技术</div>

      <div
        class="main"
      >万方数据文献相似性检测服务采用自主知识产权的全新相似度检测算法，检测高效精准、速度快。检测算法可支持多种检测功能应用，基于有效的文本预处理程序识别参考文献引用。</div>
      <div class="mains"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.title {
  display: flex;
  background: #228ef7;
}
.lefticon {
  line-height: 0.8rem;
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.3rem;
}
.title p {
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  color: #fff;
  flex: 0.85;
}
.container {
  padding: 0.3rem;
  background-color: #fff;
}
.main {
  font-size: 0.3rem;
  text-indent: 0.6rem;
  margin-bottom: 0.2rem;
  line-height: 0.7rem;
}
.mains {
  height: 5rem;
}
</style>